module.exports = __webpack_public_path__ + "static/media/location.75309f08.svg";